//common
export default function authHeader() {
    const UserAccessToken = localStorage.getItem('token');
    if (UserAccessToken) {
      return {"Authorization" : `Bearer ${UserAccessToken}`}
    } else {
      return {};
    }
  }